











import BrandDesktopActive from "library/assets/images/logos/brand/brand-desktop-active.svg"
import BrandDesktopInactive from "library/assets/images/logos/brand/brand-desktop-inactive.svg"
import BrandMobileActive from "library/assets/images/logos/brand/brand-mobile-active.svg"
import BrandMobileInactive from "library/assets/images/logos/brand/brand-mobile-inactive.svg"
import BrandFooter from "library/assets/images/logos/brand/brand-footer.svg"

import CBDDesktopActive from "library/assets/images/logos/cbd/cbd-desktop-active.svg"
import CBDDesktopInactive from "library/assets/images/logos/cbd/cbd-desktop-inactive.svg"
import CBDMobileActive from "library/assets/images/logos/cbd/cbd-mobile-active.svg"
import CBDMobileInactive from "library/assets/images/logos/cbd/cbd-mobile-inactive.svg"
import CBDFooter from "library/assets/images/logos/cbd/cbd-footer.svg"

import KitchenDesktopActive from "library/assets/images/logos/kitchen/kitchen-desktop-active.svg"
import KitchenDesktopInactive from "library/assets/images/logos/kitchen/kitchen-desktop-inactive.svg"
import KitchenMobileActive from "library/assets/images/logos/kitchen/kitchen-mobile-active.svg"
import KitchenMobileInactive from "library/assets/images/logos/kitchen/kitchen-mobile-inactive.svg"
import KitchenFooter from "library/assets/images/logos/kitchen/kitchen-footer.svg"

import SelectDesktopActive from "library/assets/images/logos/select/select-desktop-active.svg"
import SelectDesktopInactive from "library/assets/images/logos/select/select-desktop-inactive.svg"
import SelectMobileActive from "library/assets/images/logos/select/select-mobile-active.svg"
import SelectMobileInactive from "library/assets/images/logos/select/select-mobile-inactive.svg"
import SelectFooter from "library/assets/images/logos/select/select-footer.svg"


# Build a map of our logos to make it easier to acces without multiple switches
logos =
	brand:
		siteName: "Papa & Barkley"
		footer: BrandFooter
		active:
			desktop: BrandDesktopActive
			mobile: BrandMobileActive
		inactive:
			desktop: BrandDesktopInactive
			mobile: BrandMobileInactive

	cbd:
		siteName: "Papa & Barkley CBD"
		footer: CBDFooter
		active:
			desktop: CBDDesktopActive
			mobile: CBDMobileActive
		inactive:
			desktop: CBDDesktopInactive
			mobile: CBDMobileInactive

	kitchen:
		siteName: "Papa & Barkley Kitchen"
		footer: KitchenFooter
		active:
			desktop: KitchenDesktopActive
			mobile: KitchenMobileActive
		inactive:
			desktop: KitchenDesktopInactive
			mobile: KitchenMobileInactive

	select:
		siteName: "Papa & Barkley Select"
		footer: SelectFooter
		active:
			desktop: SelectDesktopActive
			mobile: SelectMobileActive
		inactive:
			desktop: SelectDesktopInactive
			mobile: SelectMobileInactive

sitesWithLogos = ['brand','cbd','kitchen','select']

export default

	props:
		noLink:
			type: Boolean
			default: false

		site:
			type: String
			default: ->
				if process.env.CMS_SITE in sitesWithLogos
					process.env.CMS_SITE
				else
					'brand'
			validator: (val) -> val in sitesWithLogos

		type:
			type: String
			default: 'active'
			validator: (val) -> val in ['active', 'inactive', 'footer']

		size:
			type: String
			default: 'large'
			validator: (val) -> val in ['small', 'large']

	computed:
		# Return the logo, if there's a size (desktop or mobile) then get that
		logo: -> logos[@site][@type]?[@computedSize] || logos[@site][@type]

		computedSize: -> if @size == 'small' then 'mobile' else 'desktop'

		alt: -> logos[@site].siteName

		# classes to style the logo differently
		classes: -> [
			"site-#{process.env.CMS_SITE}"
			"logo-#{@type}"
			"size-#{@size}"
		]

